import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-[color:var(--border)] bg-white mt-16">
      <div className="max-w-7xl mx-auto px-5 lg:px-10 py-10 grid sm:grid-cols-3 gap-6 text-sm">
        <div>
          <div className="font-display text-lg mb-2">Visit us</div>
          <a
            href="https://www.google.com/maps/dir/?api=1&destination=3910+Heron+Drive+Hood+River+OR+97031"
            target="_blank"
            rel="noreferrer"
            data-testid="footer-address-link"
            className="text-[color:var(--stone)] hover:text-[color:var(--red)] not-italic"
          >
            3910 Heron Drive<br />Hood River, OR 97031
          </a>
        </div>
        <div>
          <div className="font-display text-lg mb-2">Volunteer questions</div>
          <a
            href="mailto:volunteers@hoodriveradoptadog.org"
            data-testid="footer-email-link"
            className="text-[color:var(--stone)] hover:text-[color:var(--red)] break-all"
          >
            volunteers@hoodriveradoptadog.org
          </a>
        </div>
        <div>
          <div className="font-display text-lg mb-2">Portal</div>
          <div className="flex flex-col gap-1">
            <Link to="/shifts" className="text-[color:var(--stone)] hover:text-[color:var(--red)]">Open shifts</Link>
            <Link to="/handbook" className="text-[color:var(--stone)] hover:text-[color:var(--red)]">Volunteer handbook</Link>
            <Link to="/login" className="text-[color:var(--stone)] hover:text-[color:var(--red)]">Sign in</Link>
          </div>
        </div>
      </div>
      <div className="border-t border-[color:var(--border)] py-4 text-center text-xs text-[color:var(--stone)]">
        © Hood River Adopt A Dog · Volunteer Portal
      </div>
    </footer>
  );
}
